import { Controller } from "stimulus"

// Gère l'iframe Yousign et déclenche l'application de la modification d'abonnement après signature
export default class extends Controller {
  static values = {
    signatureLink: String,
    clientId: Number
  }

  connect() {
    // Le SDK Yousign doit être chargé via le <script> dans la vue
    this.yousign = new window.Yousign({
      signatureLink: this.signatureLinkValue,
      iframeContainerId: this.element.id,
      isSandbox: true // en prod: `false` si tu es sur l'URL non sandbox
    })

    // Événement de succès (le signataire a signé)
    this.yousign.onSuccess((_data) => {
      this.submitApplyForm()
    })

    // Écouter évènement signature
    this.yousign.on("signature.done", (_data) => {
      this.submitApplyForm()
    })
  }

  submitApplyForm() {
    const form = document.getElementById("apply-subscription-form")
    if (form) form.requestSubmit()
  }
}
